<template>
  <NavMenu/>
  <div class="page-body">
    <router-view/>
  </div>
  <FootPart/>
</template>

<script>

import FootPart from './components/FootPart/FootPart.vue'
import NavMenu from './components/NavMenu/NavMenu.vue'

export default {
  name: 'App',
  components: {
    NavMenu,
    FootPart
  },
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.page-body{
  margin-top: 160px;
}
@media screen and (max-width: 992px) {
  .page-body{
    margin-top: 100px;
  }
    
}
</style>
